import { apiV1, getToastMessage } from 'shared';
import { wagmiConfig } from 'shared/config/wagmi';
import { signMessage } from 'wagmi/actions';

import { AuthTokens } from '../types';

type GetMessageResponse = {
  message: string;
};

export const getAuthToken = async (address: string, showNotification = true) => {
  const {
    data: { message: messageToSign },
  } = await apiV1<GetMessageResponse>(`/accounts/wallet/get_message/`);

  if (showNotification) {
    getToastMessage('info', `Sign message in your wallet to procceed`);
  }

  const signedMessage = await signMessage(wagmiConfig, { message: messageToSign });

  const {
    data: { access, refresh },
  } = await apiV1<AuthTokens>(`/accounts/wallet/connect/`, {
    method: 'POST',
    data: {
      address,
      signed_msg: signedMessage,
      message: messageToSign,
    },
  });

  return { access, refresh };
};
